import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Sector } from 'src/app/models/ms_sector';
import { Referential } from 'src/app/models/referential';
import { ServiceResponse } from 'src/app/models/service-response';
import { CityService } from 'src/app/rest_services/city.service';
import { ClassService } from 'src/app/rest_services/class.service';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { SectorService } from 'src/app/rest_services/sector.service';
import { TopicService } from 'src/app/rest_services/topic.service';

@Component({
  selector: 'app-referential',
  templateUrl: './referential.component.html',
  styleUrls: ['./referential.component.css']
})
export class ReferentialComponent implements OnInit, OnDestroy {

  update:boolean=false;
  updateC:boolean=false;
  updateT:boolean=false;

  message: string = '';
  success:boolean=false;
  fail:boolean=false;
  loader:boolean=false;

  sectors: any[] = [];
  cities: Array<Referential> = [];
  topics: Array<Referential> = [];
  classes: Array<Referential> = [];


  sectorsLoader:boolean=true;
  citiesLoader:boolean=true;
  topicsLoader:boolean=true;
  classesLoader:boolean=true;

  sectorToDelete!:any;
  cityToDelete!:Referential;
  topicToDelete!:Referential;

  sectorForm!: FormGroup;
  cityForm!: FormGroup;
  topicForm!: FormGroup;

  sectorsFiltered: any[] = [];
  citiesFiltered: Array<Referential> = [];
  topicsFiltered: Array<Referential> = [];
  classesFiltered: Array<Referential> = [];

  sectorSearchForm!:FormGroup;
  citySearchForm!:FormGroup;
  topicSearchForm!:FormGroup;
  classSearchForm!:FormGroup;

  sectorsSubscription!:Subscription;
  addSectorSubscription!:Subscription;
  updateSectorSubscription!:Subscription;
  deleteSectorSubscription!:Subscription;

  citiesSubscription!:Subscription;
  addCitySubscription!:Subscription;
  updateCitySubscription!:Subscription;
  deleteCitySubscription!:Subscription;

  topicsSubscription!:Subscription;
  addTopicSubscription!:Subscription;
  updateTopicSubscription!:Subscription;
  deleteTopicSubscription!:Subscription;

  classesSubscription!:Subscription;

  token : any = '';

  constructor(private formBuilder: FormBuilder,
              private sectorService: SectorService,
              private cityService: CityService,
              private msSector : MsSectorService,
              private topicService: TopicService,
              private classService: ClassService) { }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    this.initForms();
    this.getSectors();
    this.getCities();
    this.getTopics();
    this.getClasses()
    this.sectorSearchForm.controls['search'].valueChanges.subscribe(el=>{
      this.sectorsFiltered = this.filterSectors(el);
    });
    this.citySearchForm.controls['search'].valueChanges.subscribe(el=>{
      this.citiesFiltered = this.filterCities(el);
    });
    this.topicSearchForm.controls['search'].valueChanges.subscribe(el=>{
      this.topicsFiltered = this.filterTopics(el);
    });
    this.classSearchForm.controls['search'].valueChanges.subscribe(el=>{
      this.classesFiltered = this.filterClasses(el);
    });
  }

  initForms(){
    this.sectorForm = this.formBuilder.group({
      sector:['', Validators.required],
      uuid:['']
    });
    this.cityForm = this.formBuilder.group({
      city:['', Validators.required],
      uuid:['']
    });
    this.topicForm = this.formBuilder.group({
      topic:['', Validators.required],
      uuid:['']
    });
    this.sectorSearchForm = this.formBuilder.group({
      search:[''],
    });
    this.citySearchForm = this.formBuilder.group({
      search:[''],
    });
    this.topicSearchForm = this.formBuilder.group({
      search:[''],
    });
    this.classSearchForm = this.formBuilder.group({
      search:[''],
    });
  }

  filterSectors(search: string){
    return this.sectors.filter(el => {
      if(search!=='' && search !== null && search !== undefined){
        return (el.label && el.label.toLowerCase().indexOf(search.toLowerCase()) !== -1);
      } else {
        return el;
      }
    });
  }
  
  filterCities(search: string){
    return this.cities.filter(el => {
      if(search!=='' && search !== null && search !== undefined){
        return (el.city && el.city.toLowerCase().indexOf(search.toLowerCase()) !== -1);
      } else {
        return el;
      }
    });
  }

  filterTopics(search: string){
    return this.topics.filter(el => {
      if(search!=='' && search !== null && search !== undefined){
        return (el.topic && el.topic.toLowerCase().indexOf(search.toLowerCase()) !== -1);
      } else {
        return el;
      }
    });
  }

  filterClasses(search: string){
    return this.classes.filter(el => {
      if(search!=='' && search !== null && search !== undefined){
        return (el.refClass && el.refClass.toLowerCase().indexOf(search.toLowerCase()) !== -1);
      } else {
        return el;
      }
    });
  }

  getSectors(){
    this.msSector.getSectors(this.token);
    this.msSector.sectorsSubject.subscribe(
      ( data: any ) => {
        if(data.status=="200 OK"){
          this.sectors = data.sectors;
          this.sectorsFiltered = this.sectors
          .filter((item) => item.label !== undefined)
          .sort((a, b) => {
            if (a.label && b.label) {
              return a.label.localeCompare(b.label);
            } else if (a.label) {
              return -1;
            } else {
              return 1;
            }
          });
        }
        this.sectorsLoader=false;       
      },(error :any) => {
        console.log(error);
        this.sectorsLoader=false;   
      }
    )  
  }
  getCities(){
    this.citiesSubscription = this.cityService.getCities().subscribe(
      (data: ServiceResponse) => {
        if(data.code == "9d0907561104ccc6b9d188f036bd358c"){
          this.cities = data.cities?data.cities:[];
          this.citiesFiltered = this.cities
          .filter((item) => item.city !== undefined) // Filter out elements with undefined city
          .sort((a, b) => {
            if (a.city && b.city) {
              return a.city.localeCompare(b.city);
            } else if (a.city) {
              return -1;
            } else {
              return 1;
            }
          });
        }
        this.citiesLoader=false;         
      },
      (error) => {
        console.log(error);
        this.citiesLoader=false;   
      }
    );
  }

  getTopics(){
    this.topicsSubscription = this.topicService.getTopics().subscribe(
      (data: ServiceResponse) => {
        if(data.code == "d9cc2e7dc2cf71242be86ab1ad241752"){
          this.topics = data.topics?data.topics:[];
          this.topicsFiltered = this.topics
          .filter((item) => item.topic !== undefined) // Filter out elements with undefined topic
          .sort((a, b) => {
            if (a.topic && b.topic) {
              return a.topic.localeCompare(b.topic);
            } else if (a.topic) {
              return -1;
            } else {
              return 1;
            }
          });
        }
        this.topicsLoader=false;         
      },
      (error) => {
        console.log(error);
        this.topicsLoader=false;   
      }
    );
  }

  getClasses(){
    this.classesSubscription = this.classService.getClasses().subscribe(
      (data: ServiceResponse) => {
        if(data.code == "7cd8d69b7048301e37f4ddaf4959218c"){
          this.classes = data.classes?data.classes:[];
          this.classesFiltered = this.classes;
        }
        this.classesLoader=false;         
      },
      (error) => {
        console.log(error);
        this.classesLoader=false;   
      }
    );
  }

  addSector(){
    this.message = 'Ajout du secteur';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    this.update=false;
    let sector :any ={};
    sector.label = this.sectorForm.controls.sector.value;
    this.msSector.addSector(this.token, sector);
    this.msSector.newSectorSubject.subscribe(
      (data: any) => {
        if(data.message == "Sector already exist !"){
          this.loader=false;
          this.message = 'Secteur existe déja';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        } else if(data.message == "Invalid data !" || data.message =="Technical error"){
          this.loader=false;
          this.message = 'Secteur non ajouté';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }else {
          let sectorAdded = data.sector;
          if(sectorAdded){
            let sect:any = {label:sectorAdded.label?sectorAdded.label:"",id:sectorAdded.id};
            this.sectors.push(sect);
            this.sectorsFiltered= this.sectors.sort((a : any, b : any) => a.label.localeCompare(b.label)); //sort sectors alphabetically;
          }
          this.sectorForm.reset();
          this.loader=false;
          this.message = 'Secteur ajouté avec succès';
          this.success = true;
          
          setTimeout(() => {
            this.success = false;
          }, 5000);
        }
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Secteur non ajouté';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  updateSector(item:any){
    this.update=true;
    this.sectorForm.patchValue({
      sector: item.label,
      uuid: item.id
    })
  }

  submitToUpdateSector(){
    this.message = 'Modification du secteur';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    let sector:any ={};
    sector.label = this.sectorForm.controls.sector.value;
    sector.id = this.sectorForm.controls.uuid.value;
    this.msSector.updateSector(this.token, sector);
    this.msSector.updateSectorSubject.subscribe(
      (data: any) => {
        if (data.message && data.message.includes("updated with success")) {
          let index = this.sectors?.findIndex(e=>e.id == sector.id)
          if(index!=undefined){
            this.sectors?.splice(index,1,sector);
            this.sectorsFiltered= this.sectors;
          }
          this.sectorForm.reset();
          this.loader=false;
          this.update=false;
          this.message = 'Secteur modifié avec succès';
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 5000);
        } else if (data.message == "Sector already exist !") {
          this.loader=false;
          this.message = 'Secteur existe déja'
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        } else {
          this.loader=false;
          this.message = 'Secteur non modifié'
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Secteur non modifié';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  getSector(sector:any){
    this.sectorToDelete = sector;
  }

  deleteSector(id:string){
    this.message = 'Suppression du secteur';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    this.deleteSectorSubscription = this.sectorService.deleteSector(id).subscribe(
      (data: ServiceResponse) => {
        if(data.code == "68eb94594d32c0cb4942b385e1bafc39") {
          this.loader=false;
          this.message = 'Secteur non supprimé: des clients appartiennentt à ce secteur';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        } 
        else {
          this.msSector.deleteSector(this.token, id);
          this.msSector.deleteSectorSubject.subscribe(
            (response: any) => {
              if (response.message && response.message.includes("deleted successfully")) {
                let index = this.sectors?.findIndex(e=>e.id == id)
                if(index!=undefined){
                  this.sectors.splice(index,1);
                  this.sectorsFiltered= this.sectors;
                }
                this.loader=false;
                this.message = 'Secteur supprimé avec succès';
                this.success = true;
                setTimeout(() => {
                  this.success = false;
                }, 5000);
              } else if(response.message && response.message.includes("Sector not found")) {
                this.loader=false;
                this.message = 'Secteur n\'existe pas';
                this.fail = true;
                setTimeout(() => {
                  this.fail = false;
                }, 5000);
              } else {
                this.loader=false;
                this.message = 'Secteur non supprimé';
                this.fail = true;
                setTimeout(() => {
                  this.fail = false;
                }, 5000);
              }
                     
            },
            (error) => {
              console.log(error);
              this.loader=false;
              this.message = 'Secteur non supprimé';
              this.fail = true;
              setTimeout(() => {
                this.fail = false;
              }, 5000);
            }
          );
        }      
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Secteur non supprimé';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  addCity(){
    this.message = 'Ajout de la ville';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    this.updateC = false;
    let city = new Referential();
    city.name = this.cityForm.controls.city.value;
    this.addCitySubscription = this.cityService.addCity(city).subscribe(
      (data: ServiceResponse) => {
        if (data.code == "5885ba91e80c4507cb1e35548129c3c0") {
          let topicAdded = data.city;
          if(topicAdded){
            let cit:Referential = {city:topicAdded.name?topicAdded.name:"",uuid:topicAdded.uuid}
            this.cities.push(cit);
            this.citiesFiltered= this.cities.sort((a : any, b : any) => a.city.localeCompare(b.city)); //sort cities alphabetically;
          }
          this.cityForm.reset();
          this.loader=false;
          this.message = 'Ville ajoutée avec succès';
          this.success = true;
          
          setTimeout(() => {
            this.success = false;
          }, 5000);
        } else if(data.code == "a6e243dd4f515aa112410877740174b8") {
          this.loader=false;
          this.message = 'Ville existe déja';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        } else {
          this.loader=false;
          this.message = 'Ville non ajoutée';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'ville non ajoutée';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  updateCity(item:Referential){
    this.updateC=true;
    this.cityForm.patchValue({
      city: item.city,
      uuid: item.uuid
    })
  }

  submitToUpdateCity(){
    this.message = 'Modification de la ville';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    let city = new Referential();
    city.name = this.cityForm.controls.city.value;
    city.uuid = this.cityForm.controls.uuid.value;
    this.updateCitySubscription = this.cityService.updateCity(city).subscribe(
      (data: ServiceResponse) => {
        if (data.code == "5876ea7b868466034493a62859371897") {
          let el= new Referential();
          el.uuid = data.city?.uuid? data.city?.uuid: '';
          el.city = data.city?.name;
          let index = this.cities?.findIndex(e=>e.uuid == el.uuid)
          if(index != null){
            this.cities?.splice(index,1,el);
          }
          this.citiesFiltered= this.cities;
          this.cityForm.reset();
          this.loader=false;
          this.updateC=false;
          this.message = 'Ville modifiée avec succès';
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 5000);
        } else if (data.code == "7539deff3efc02fe4e93aceb4a9885f7"){
          this.loader=false;
          this.message = 'Ville existe déja'
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }else{
          this.loader=false;
          this.message = 'Ville non modifiée'
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Ville non modifiée';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  getCity(city:Referential){
    this.cityToDelete = city;
  }

  deleteCity(uuid:string){
    this.message = 'Suppression de la ville';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    this.deleteCitySubscription = this.cityService.deleteCity(uuid).subscribe(
      (data: ServiceResponse) => {
        if (data.code == "2b7a32a45799ce3f0e8dc7ee146b5338") {
          let index = this.cities?.findIndex(e=>e.uuid == uuid)
          if(index)
          this.cities?.splice(index,1);
          this.citiesFiltered= this.cities;
          this.loader=false;
          this.message = 'Ville supprimée avec succès';
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 5000);
          
        } else if (data.code == "3a5f4469b340d70b897b82d38533b4f4") {
          this.loader=false;
          const nbCustomer = data.totalCustomers;
          this.message = `Suppression impossible : cette ville est affectée à ${nbCustomer} clients`;
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 7000);
        } else {
          this.loader=false;
          this.message = 'Ville non supprimée';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Ville non supprimée';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  addTopic(){
    this.message = 'Ajout du topic';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    this.updateT = false;
    let topic = new Referential();
    topic.name = this.topicForm.controls.topic.value;
    this.addTopicSubscription = this.topicService.addTopic(topic).subscribe(
      (data: ServiceResponse) => {
        if (data.code == "662a1237ac8d60871bec841ac4a29e7e") {
          let topicAdded = data.topic;
          if(topicAdded) {
            let top:Referential = {topic:topicAdded.name?topicAdded.name:"",uuid:topicAdded.uuid}
            this.topics.push(top);
            this.topicsFiltered= this.topics.sort((a : any, b : any) => a.topic.localeCompare(b.topic)); //sort topics alphabetically;
          }
          this.topicForm.reset();
          this.loader=false;
          this.message = 'topic ajouté avec succès';
          this.success = true;
          
          setTimeout(() => {
            this.success = false;
          }, 5000);
        } else if (data.code == "53765b8627704f3f4104bdf8a667179f") {
          this.loader=false;
          this.message = 'topic existe déja';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        } else {
          this.loader=false;
          this.message = 'topic non ajouté';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'topic non ajouté';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  updateTopic(item:Referential){
    this.updateT=true;
    this.topicForm.patchValue({
      topic: item.topic,
      uuid: item.uuid
    })
  }

  submitToUpdateTopic(){
    this.message = 'Modification du topic';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    let topic = new Referential();
    topic.name = this.topicForm.controls.topic.value;
    topic.uuid = this.topicForm.controls.uuid.value;
    this.updateTopicSubscription = this.topicService.updateTopic(topic).subscribe(
      (data: ServiceResponse) => {
        if (data.code == "afcbd1b891d62ba8b6916cb430c2b5de") {
          let el= new Referential();
          el.uuid = data.topic?.uuid? data.topic?.uuid: '';
          el.topic = data.topic?.name;
          let index = this.topics?.findIndex(e=>e.uuid == el.uuid)
          if(index != null){
            this.topics?.splice(index,1,el);
          }
          this.topicsFiltered= this.topics;
          this.topicForm.reset();
          this.loader=false;
          this.updateT=false;
          this.message = 'Topic modifié avec succès';
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 5000);
        } else if(data.code == "984fea95f7a405a95d7fc0b403b2ef82"){
          this.loader=false;
          this.message = 'Topic existe déja'
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        } else {
          this.loader=false;
          this.message = 'Topic non modifié'
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Topic non modifié';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  getTopic(topic:Referential){
    this.topicToDelete = topic;
  }

  deleteTopic(uuid:string){
    this.message = 'Suppression du topic';
    this.loader=true;
    $("html, body").animate({scrollTop:0});
    this.deleteTopicSubscription = this.topicService.deleteTopic(uuid).subscribe(
      (data: ServiceResponse) => {
        if (data.code == "b1747f8a235636d87190d1b1c8eb0fa8") {
          let index = this.topics?.findIndex(e=>e.uuid == uuid)
          if(index)
          this.topics?.splice(index,1);
          this.topicsFiltered= this.topics;
          this.loader=false;
          this.message = 'Topic supprimé avec succès';
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 5000);
          
        } else if (data.code == "c309e1dfed3ab769f14063719353327a"){
          this.loader=false;
          this.message = 'Topic non supprimé: des vistes ont ce topic';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        } else {
          this.loader=false;
          this.message = 'Topic non supprimé';
          this.fail = true;
          setTimeout(() => {
            this.fail = false;
          }, 5000);
        }
               
      },
      (error) => {
        console.log(error);
        this.loader=false;
        this.message = 'Topic non supprimé';
        this.fail = true;
        setTimeout(() => {
          this.fail = false;
        }, 5000);
      }
    );
  }

  ngOnDestroy(): void {
    this.sectorsSubscription?.unsubscribe();
    this.addSectorSubscription?.unsubscribe();
    this.updateSectorSubscription?.unsubscribe();
    this.deleteSectorSubscription?.unsubscribe();
  
    this.citiesSubscription?.unsubscribe();
    this.addCitySubscription?.unsubscribe();
    this.updateCitySubscription?.unsubscribe();
    this.deleteCitySubscription?.unsubscribe();
  
    this.topicsSubscription?.unsubscribe();
    this.addTopicSubscription?.unsubscribe();
    this.updateTopicSubscription?.unsubscribe();
    this.deleteTopicSubscription?.unsubscribe();

    this.classesSubscription?.unsubscribe();
  }

}
